export default __webpack_public_path__ + "static/media/breakfast.42d87c78.png";